exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grabbable {\n  cursor: move; /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  cursor: -webkit-grab;\n\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n/* (Optional) Apply a \"closed-hand\" cursor during drag operation. */\n.grabbable:active {\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n}\n.handle-icon.el-icon-rank {\n  width: 100%;\n  height: 30px;\n  text-align: center;\n  font-size: 16px;\n  line-height: 30px;\n}\n", ""]);

// exports
